import { Parallax } from "../lib/Parallax.mjs";
Parallax.parseWordActivate();
Parallax.init(document, {resize: false});

import {ScreenContrast} from "../lib/ScreenContrast.mjs";
window.screenContrast = new ScreenContrast(document.querySelectorAll('.screen-dark'));

import { Panels } from "../lib/Panels.mjs";
Panels.init();

document.querySelectorAll('*[data-action="panel-open"]').forEach(el=>{
  const target = 'panel-'+el.getAttribute('data-target');

  el.addEventListener('click', evt => {
    evt.preventDefault();
    document.getElementById(target).classList.add('active');
    return false;
  })
})
